import { TouchBallLoading } from "react-loadingg";
export default function Loader() {
  return (
    <>
      <div
        className="loader-container"
        style={{
          position: "fixed",
          left: "0",
          right: "0",
          top: "0",
          bottom: "0",
          overflow: "hidden",
          backgroundColor: "rgba(209, 225, 240,0.7)",
          zIndex: 5,
        }}
      >
        <TouchBallLoading />
      </div>
    </>
  );
}
